import { render, staticRenderFns } from "./RowBlockInvoiceForPartnerByAdmin.vue?vue&type=template&id=4be85d39&"
import script from "./RowBlockInvoiceForPartnerByAdmin.vue?vue&type=script&lang=js&"
export * from "./RowBlockInvoiceForPartnerByAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports